import {Col, Row} from "antd";
import styled from "styled-components";

export const PickupInformationContainer = styled(Row)`
    width: 100%;
    border-bottom: 1px dashed #c6c5c5;
    padding: 20px 0;
    flex-direction: column;
    gap: 20px !important;
`;

// Customer-specific compact pickup information container
export const CustomerPickupInformationContainer = styled(Row)`
    width: 100%;
    border-bottom: 1px dashed #c6c5c5;
    padding: 8px 0;
    flex-direction: column;
    gap: 6px !important;
`;

export const PickupInformationHeader = styled(Col)`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    font-weight: bold;
`;

// Customer-specific compact header
export const CustomerPickupInformationHeader = styled(Col)`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    font-weight: bold;
    margin-bottom: 8px;
`;

export const PickupInformationTitle = styled(Col)`
    font-size: 18px;
    margin-left: 7px;
`;

// Customer-specific compact title
export const CustomerPickupInformationTitle = styled(Col)`
    font-size: 16px;
    margin-left: 7px;
`;

export const CreditLabel = styled.div`
    font-size: 30px;
    font-weight: 900;
    line-height: initial;
`;

// Customer-specific compact credit label
export const CustomerCreditLabel = styled.div`
    font-size: 24px;
    font-weight: 900;
    line-height: initial;
`;
